import { createFinancialDocumentsViewConfig } from "@common/helpers/close-template-task-view-config";
import { omit } from "@common/helpers/objects";
import { FiltersTypes } from "@common/types/filters/general";
import {
    FinancialDocumentColumn,
    FinancialDocumentView,
    FinancialDocumentViewSchema,
} from "@common/types/views/financialDocumentViews";
import { PersistableView } from "@common/types/views/views";
import { parseTaskView } from "../shared/taskTableView";

export function defaultFinancialDocumentsView(): FinancialDocumentView {
    return FinancialDocumentViewSchema.parse(
        createFinancialDocumentsViewConfig(),
    );
}

export function parseFinancialDocumentsTaskView(
    raw: object | null | undefined,
): FinancialDocumentView {
    return parseTaskView({
        schema: FinancialDocumentViewSchema,
        raw,
        createDefaultView: defaultFinancialDocumentsView,
    });
}

const TASK_SCOPE_KEYS = ["entityIds", "financialDocumentIds"] as const;

export function omitTaskScope(filters: FiltersTypes): FiltersTypes {
    return omit(filters, [...TASK_SCOPE_KEYS]);
}

export function serializeFinancialDocumentsTemplateView(
    view: FinancialDocumentView,
): FinancialDocumentView {
    return { ...view, filters: omitTaskScope(view.filters) };
}

interface BuildBulkTaskViewParams {
    view: FinancialDocumentView;
    financialDocumentIds?: number[];
    filters?: FiltersTypes;
    entityIds?: number[];
}

export function buildBulkFinancialDocumentsTaskView({
    view,
    financialDocumentIds,
    filters = {},
    entityIds,
}: BuildBulkTaskViewParams): PersistableView {
    return {
        ...omit(view, ["originalFilters"]),
        columns: view.columns.filter(
            (column) => column.id !== FinancialDocumentColumn.ACTIONS,
        ),
        filters: {
            ...filters,
            ...(entityIds?.length ? { entityIds } : {}),
            ...(financialDocumentIds?.length ? { financialDocumentIds } : {}),
        },
        options: { ...view.options, selection: true, bulkActions: true },
    };
}
